import { residentApiWithAuth } from '../../api/resident';

export const unitHasPeopleType = async(unitId: string, peopleTypeId: string) => {
    try {
      const res = await residentApiWithAuth().get(
        `/units/checkPeopleType/${unitId}/${peopleTypeId}`,
      );
      const result = res.data;
      if (result.errors) {
        throw new Error(result.errors[0]);
      }
    return result.data;
    } catch (error) {
      throw new Error(error.message);
    }
}